import React from "react";

const NotFound = () => {
  return <div>We're sorry! This page doesn't exist.</div>;
};

export default NotFound;
